import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
`

export const ActivityIndicatorWrapper = styled.div`
  position: absolute;
  top: var(--space-n50);
  right: var(--space-n50);
`
